import { useTranslation, Trans } from "react-i18next";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ContactForm from "../../pages/Consultation";

import CountUp from 'react-countup';

import main from '../../img/main.png';
import main2 from '../../img/main2.png'

import notebook from '../../img/notebook.png'

function Main () {

    const { t } = useTranslation();

    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: '', email: '', text: '', checkbox: false });

    const handleSubmit = () => {
        navigate('/consultation', { state: formData });
    };
      
    return(
        <>
            <div className="overflow-hidden relative xl:h-[770px] max-w-[1220px] mx-[20px] xl:mx-auto bg-[#382F12] mt-[60px] xl:mt-[0px]">
                <div className="flex flex-col md:flex-row gap-[0px] sm:gap-[40px] xl:gap-0 justify-between xl:px-[40px]">
                    <div className="pt-[30px] xl:pt-[150px] relative z-20 px-[20px] xl:px-0 w-full flex flex-col items-start">
                        <p className="leading-[1.2] text-[#E9E4DA] text-[40px] md:text-[60px] xl:text-[96px] font-[600] host-grotesk">{t('home.1')}</p>
                        <p className="host-grotesk text-[32px] xl:text-[48px] leading-[1.2] font-[300] xl:max-w-[759px] text-[#E9E4DA] span:text-[#FC2E00]"><Trans i18nKey="home.2" components={{ span: <span className="text-[#FC2E00]" /> }} /></p>
                        <div className="bg-[#504830] h-px w-full mt-[20px] xl:mt-[215px]"></div>
                        <p className="mt-[20px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('home.3')}</p>
                        <p className="mt-[8px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2] font-[700]">{t('home.4')}</p>
                        <p className="rounded-[8px] bg-[#FC2E00] text-white uppercase PtRoot font-[700] py-[14px] xl:absolute right-0 px-[40px] mt-[30px] xl:mt-0 mb-[40px] xl:mb-0 bottom-[30px] hover:px-[20px] transition-all">{t('home.8')}</p>
                    </div>
                    <img src={main} className="hidden xl:block absolute right-0" alt="" />
                    <img src={main2} className="xl:hidden block" alt="" />
                </div>
            </div>
            <div className="overflow-hidden relative xl:h-[171px] flex flex-col justify-center max-w-[1220px] mx-[20px] xl:mx-auto bg-[#504830] py-[30px] xl:py-0">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
                    <div className="flex flex-col items-center">
                        <div className="host-grotesk font-[700] leading-[1.4] text-[40px] xl:text-[64px] text-white flex">
                            <CountUp end={60} />
                            <p className="text-[#FC2E00]">+</p>
                        </div>
                        <p className="PtRoot text-[#FFFFFFB2] text-[16px] xl:text-[20px]">{t('home.5')}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="host-grotesk font-[700] leading-[1.4] text-[40px] xl:text-[64px] text-white flex">
                            <CountUp end={320} />К
                            <p className="text-[#FC2E00]">+</p>
                        </div>
                        <p className="PtRoot text-[#FFFFFFB2] text-[16px] xl:text-[20px]">{t('home.6')}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="host-grotesk font-[700] leading-[1.4] text-[40px] xl:text-[64px] text-white flex">
                            <CountUp end={1000} />
                            <p className="text-[#FC2E00]">+</p>
                        </div>
                        <p className="PtRoot text-[#FFFFFFB2] text-[16px] xl:text-[20px]">{t('home.7')}</p>
                    </div>
                </div>
            </div>
            <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col-reverse md:flex-row gap-[60px] md:gap-[20px] xl:gap-[60px] pt-[80px] xl:pt-0">
                <img src={notebook} alt="Notebook"/>
                <div className="xl:pt-[90px]">
                    <p className="host-grotesk leading-[1.2] xl:max-w-[511px] xl:text-[40px] text-[#382F12] text-[28px]">{t('home.9')}</p>
                    <p className="mt-[12px] xl:mt-[27px] xl:max-w-[497px] PtRoot text-[#000000B2] text-[12px] xl:text-[14px]">{t('home.10')}</p>
                    <form className="mt-[24px] flex flex-col items-start relative gap-[12px] xl:gap-[16px] xl:max-w-[437px]">
                        {/* Full name */}
                        <input
                            type="text"
                            placeholder={t('home.42')}
                            className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-4 py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080]"
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                        {/* Email */}
                        <input
                            type="email"
                            placeholder={t('home.43')}
                            className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-4 py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080]"
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        />
                        {/* Message */}
                        <textarea
                            placeholder={t('home.44')}
                            rows={3}
                            className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-4 py-3 text-[14px] focus:outline-none focus:border-[#382F12] placeholder-[#00000080] resize-none"
                            onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                        ></textarea>

                        {/* Чекбокс */}
                        <label className="flex items-center gap-2 text-[12px] xl:text-[14px] text-[#000000B2] cursor-pointer PtRoot font-[700]">
                            <input type="checkbox" className="accent-[#E95420] w-[14px] h-[14px]" onChange={(e) => setFormData({ ...formData, checkbox: e.target.checked })} />
                            {t('home.45')}
                        </label>

                        {/* Кнопка */}
                        <p onClick={handleSubmit} className="rounded-[8px] cursor-pointer bg-[#FC2E00] xl:mt-[32px] text-white uppercase PtRoot font-[700] py-[14px] px-[40px] hover:px-[20px] transition-all">{t('home.46')}</p>

                    </form>
                </div>
            </div>
        </>
    );
}

export default Main;